export type ImageType = {
  path: string;
  description: string;
  source: string | null;
  svg: boolean;
};

export type Player = {
  id: number;
  slug: string;
  firstName: string;
  lastName: string;
  image: ImageType;
  matches: number;
  goals: number;
  assists: number;
  penaltiesTotal: number;
  penaltiesHit: number;
  yellowCards: number;
  yellowRedCards: number;
  redCards: number;
  substitutesIn: number;
  substitutesOut: number;
  minutesPlayed: number;
  topEleven?: number;
};

export type ErrorData = {message: string; status: number} | null;

export interface Links {
  first: string | null;
  last: string | null;
  prev: string | null;
  next: string | null;
}

export interface Meta {
  currentPage: number;
  from: number;
  lastPage: number;
  path: string;
  perPage: number;
  to: number;
  total: number;
}

export interface PlayerStatsAlltimeResponse {
  data: Player[];
  links: Links | null;
  meta: Meta | null;
}

export enum PlayerStatsSeasonActionTypes {
  FETCHING = 'PLAYER_STATS_SEASON_FETCHING',
  UPDATE = 'PLAYER_STATS_SEASON_UPDATE',
  ERROR = 'PLAYER_STATS_SEASON_ERROR',
}

export enum PlayerStatsAlltimeActionTypes {
  FETCHING = 'PLAYER_STATS_ALLTIME_FETCHING',
  UPDATE = 'PLAYER_STATS_ALLTIME_UPDATE',
  ERROR = 'PLAYER_STATS_ALLTIME_ERROR',
  ADD = 'PLAYER_STATS_ALLTIME_ADD',
  SORTMODEL = 'PLAYER_STATS_ALLTIME_UPDATE_SORTMODEL',
}
